export default class PasswordResetSuccessView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.password-reset-success-view');
        this.ctaButton = this.el.querySelector('.password-reset-success-cta');
        this.bind();
    }

    bind() {
        this.ctaButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.parent.show({ view: 'login' });
        });
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
